import { render } from "./off_course_invoice_create.vue?vue&type=template&id=0dbf6d02&scoped=true"
import script from "./off_course_invoice_create.vue?vue&type=script&lang=js"
export * from "./off_course_invoice_create.vue?vue&type=script&lang=js"

import "./off_course_invoice_create.vue?vue&type=style&index=0&id=0dbf6d02&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbf6d02"]])

export default __exports__